import { render, staticRenderFns } from "./remoteFiles.vue?vue&type=template&id=4059725a&scoped=true"
import script from "./remoteFiles.vue?vue&type=script&lang=js"
export * from "./remoteFiles.vue?vue&type=script&lang=js"
import style0 from "./remoteFiles.vue?vue&type=style&index=0&id=4059725a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4059725a",
  null
  
)

export default component.exports